import React, { useState } from 'react';
import { Button } from '@mellify/ui';
import { UserPlus } from 'lucide-react';
import { InviteMemberModal } from './components/InviteMemberModal';
import { usePermission } from '../../../hooks/usePermission';

/**
 * TeamPageActions
 *
 * Header actions for the Team Members page.
 * Opens the InviteMemberModal when "Invite Member" is clicked.
 * Only visible to users with the 'manage_team' permission.
 */
export const TeamPageActions: React.FC = () => {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const canManageTeam = usePermission('manage_team');

  if (!canManageTeam) {
    return null;
  }

  return (
    <>
      <Button
        variant="primary"
        size="md"
        leftIcon={<UserPlus className="w-4 h-4" />}
        onClick={() => setIsInviteModalOpen(true)}
      >
        Invite Member
      </Button>

      <InviteMemberModal
        open={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
      />
    </>
  );
};

TeamPageActions.displayName = 'TeamPageActions';